// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/flags.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flag {
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 100px 0;
  transform: scale(0.8);
  transform-origin: left center;
}

.flag[country="flag_home"] {
  background-image: none;
}

/* .flag[country='flag_worldcup'] {
  background-position: -287px -384px;
} */

.flag[country="flag_4"],
.flag[country="flag_4"],
.flag[country="flag_103"],
.flag[country="flag_225"],
.flag[country="flag_56"],
.flag[country="flag_1000408"],
.flag[country="flag_73"],
.flag[country="flag_80"],
.flag[country="flag_27"],
.flag[country="flag_1718"],
.flag[country="flag_1000329"],
.flag[country="flag_120"],
.flag[country="flag_777"],
.flag[country="flag_96"],
.flag[country="flag_55"],
.flag[country="flag_88"],
.flag[country="flag_105"],
.flag[country="flag_104"],
.flag[country="flag_136"],
.flag[country="flag_166"],
.flag[country="flag_161"],
.flag[country="flag_164"],
.flag[country="flag_178"],
.flag[country="flag_250"],
.flag[country="flag_259"],
.flag[country="flag_266"],
.flag[country="flag_290"],
.flag[country="flag_295"],
.flag[country="flag_371"],
.flag[country="flag_446"],
.flag[country="flag_504"],
.flag[country="flag_577"],
.flag[country="flag_756"],
.flag[country="flag_2025"],
.flag[country="flag_1038"],
.flag[country="flag_2030"],
.flag[country="flag_992"],
.flag[country="flag_990"],
.flag[country="flag_2033"],
.flag[country="flag_1495"],
.flag[country="flag_2037"],
.flag[country="flag_2038"],
.flag[country="flag_993"],
.flag[country="flag_850"],
.flag[country="flag_987"],
.flag[country="flag_96"],
.flag[country="flag_2082"],
.flag[country="flag_1715"],
.flag[country="flag_1731"],
.flag[country="flag_1780"],
.flag[country="flag_2032"],
.flag[country="flag_393"] {
  /*international*/
  background-position: -239px -384px;
}

.flag[country="flag_uefachampionsleague"] {
  background-position: -47px -72px;
  filter: invert(0);
}

.flag[country="flag_uefaeuropaleague"] {
  background-position: -336px -96px;
}

.flag[country="flag_copaamericacnt"] {
  background-position: -264px -72px;
  width: 24px;
  height: 24px;
  margin-left: 10px;
}

.flag[country="flag_wta"] {
  background-position: -1px -405px;
}

.flag[country="flag_"] {
  background-position: -25px -405px;
}

.flag[country="flag_itf"] {
  background-position: -50px -405px;
  transform: scale(0.8);
}

.flag[country="flag_challenger"] {
  background-position: -74px -405px;
}

.flag .flag[country="flag_daviscup"] {
  background-position: -149px -405px;
}

.flag[country="flag_fedcup"] {
  background-position: -173px -405px;
}

.flag[country="flag_euro"] {
  background-position: -336px -385px;
}

.flag[country="flag_asean"] {
  background-position: 0 0;
}

.flag[country="flag_310"] {
  background-position: -216px -291px;
}

.flag[country="flag_322"] {
  background-position: -120px -315px;
}

.flag[country="flag_african-union-oas"] {
  background-position: -72px 0;
}

/* .flag[country='flag_166'] {
  background-position: -96px 0;
} */

.flag[country="flag_304"],
.flag[country="flag_304"],
.flag[country="flag_1000318"],
.flag[country="flag_1000277"],
.flag[country="flag_1000143"] {
  /*algeria*/
  background-position: -120px 0;
}

.flag[country="flag_america"],
.flag[country="flag_26"],
.flag[country="flag_15"],
.flag[country="flag_16"],
.flag[country="flag_37"],
.flag[country="flag_43"],
.flag[country="flag_814"],
.flag[country="flag_988"],
.flag[country="flag_450"],
.flag[country="flag_1713"] {
}

.flag[country="flag_500"] {
  /*angola*/
  background-position: -216px 0;
}

.flag[country="flag_385"] {
  background-position: -72px -3px;
}

.flag[country="flag_arab-league"] {
  background-position: -312px 0;
}

.flag[country="flag_48"],
.flag[country="flag_264"],
.flag[country="flag_99000066"],
.flag[country="flag_1000175"],
.flag[country="flag_374"],
.flag[country="flag_1000237"],
.flag[country="flag_99000097"] {
  /*argentina*/
  background-position: -336px 0;
}

.flag[country="flag_296"],
.flag[country="flag_296"],
.flag[country="flag_1000300"],
.flag[country="flag_2113"] {
  /*armenia*/
  background-position: -360px 0;
}

.flag[country="flag_asia"] {
  background-position: -24px -24px;
}

.flag[country="flag_34"],
.flag[country="flag_34"],
.flag[country="flag_113"],
.flag[country="flag_775"],
.flag[country="flag_878"],
.flag[country="flag_87"],
.flag[country="flag_1723"],
.flag[country="flag_491"],
.flag[country="flag_1000307"],
.flag[country="flag_99000104"],
.flag[country="flag_99000142"] {
  /*australia*/
  background-position: -48px -24px;
}

.flag[country="flag_17"],
.flag[country="flag_17"],
.flag[country="flag_170"],
.flag[country="flag_65"],
.flag[country="flag_99000044"],
.flag[country="flag_69"],
.flag[country="flag_128"],
.flag[country="flag_1000358"],
.flag[country="flag_99000015"]
  .flag[country="flag_97"]
  .flag[country="flag_1000341"] {
  /*austria*/
  background-position: -72px -24px;
}

.flag[country="flag_173"],
.flag[country="flag_297"],
.flag[country="flag_1000314"],
.flag[country="flag_1000374"] {
  /*azerbaijan*/
  background-position: -96px -24px;
}

.flag[country="flag_469"],
.flag[country="flag_834"] {
  /*bangladesh*/
  background-position: -168px -24px;
}

.flag[country="flag_91"],
.flag[country="flag_91"],
.flag[country="flag_1000271"],
.flag[country="flag_275"],
.flag[country="flag_1000405"],
.flag[country="flag_400"],
.flag[country="flag_1000266"],
.flag[country="flag_99000095"],
.flag[country="flag_750"],
.flag[country="flag_1000294"],
.flag[country="flag_741"],
.flag[country="flag_1000161"] {
  /*belarus*/
  background-position: -216px -24px;
}

.flag[country="flag_33"],
.flag[country="flag_189"],
.flag[country="flag_256"],
.flag[country="flag_1000359"] {
  /*belgium*/
  background-position: -240px -24px;
}

.flag[country="flag_379"],
.flag[country="flag_99000025"],
.flag[country="flag_1525"],
.flag[country="flag_99000129"] {
  /*bolivia*/
  background-position: -360px -24px;
}

.flag[country="flag_95"]
/* Austra Ametuer */


.flag[country="flag_158"] {
  background-position: 0 -48px;
}

.flag[country="flag_13"],
.flag[country="flag_263"],
.flag[country="flag_1000146"],
.flag[country="flag_2152"],
.flag[country="flag_373"],
.flag[country="flag_1000166"],
.flag[country="flag_202"],
.flag[country="flag_99000139"],
.flag[country="flag_772"] {
  /*brazil*/
  background-position: -72px -48px;
}

.flag[country="flag_78"],
.flag[country="flag_78"],
.flag[country="flag_372"],
.flag[country="flag_1000297"],
.flag[country="flag_332"],
.flag[country="flag_99000004"] {
  /*bulgaria*/
  background-position: -120px -48px;
}

.flag[country="flag_caricom"] {
  background-position: -192px -48px;
}

.flag[country="flag_cis"] {
  background-position: -216px -48px;
}

.flag[country="flag_852"],
.flag[country="flag_1000235"] {
  /*cambodia*/
  background-position: -240px -48px;
}

.flag[country="flag_391"],
.flag[country="flag_1805"],
.flag[country="flag_1000394"],
.flag[country="flag_99000023"] {
  /*cameroon*/
  background-position: -288px -48px;
}

.flag[country="flag_388"],
.flag[country="flag_388"],
.flag[country="flag_876"],
.flag[country="flag_176"],
.flag[country="flag_93"],
.flag[country="flag_99000149"] {
  /*canada*/
  background-position: -312px -48px;
}

.flag[country="flag_championsleague"] {
  background-position: -48px -72px;
}

.flag[country="flag_49"],
.flag[country="flag_828"],
.flag[country="flag_1000246"] {
  /*chile*/
  background-position: -72px -72px;
}

.flag[country="flag_99"],
.flag[country="flag_548"],
.flag[country="flag_1000220"],
.flag[country="flag_718"],
.flag[country="flag_1000416"],
.flag[country="flag_771"],
.flag[country="flag_99000131"] {
  /*china*/
  background-position: -96px -72px;
}

.flag[country="flag_274"],
.flag[country="flag_1000283"],
.flag[country="flag_99000030"],
.flag[country="flag_99000090"] {
  /*colombia*/
  background-position: -120px -72px;
}

.flag[country="flag_commonwealth"] {
  background-position: -144px -72px;
}

.flag[country="flag_351"] {
  background-position: -144px -27px;
}

.flag[country="flag_367"] {
  background-position: -168px -243px;
}

.flag[country="flag_755"] {
  background-position: -71px -266px;
}

.flag[country="flag_congo-brazzaville"] {
  background-position: -192px -72px;
}

.flag[country="flag_congo-kinshasa"] {
  background-position: -216px -72px;
}

/* .flag[country='flag_194'] {
  background-position: -240px -72px;
} */

.flag[country="flag_copaamerica"] {
  background-position: -264px -72px;
}

/* .flag[country='flag_198'] {
  
  background-position: -288px -72px;
} */

.flag[country="flag_cote-divoire"] {
  background-position: -312px -72px;
}

.flag[country="flag_14"] {
  /*croatia*/
  background-position: -336px -72px;
}

/* .flag[country='flag_199'] {
  background-position: -360px -72px;
} */

/* .flag[country='flag_75'] {
  background-position: 0 -96px;
} */

/* .flag[country='flag_202'] {
  background-position: -24px -96px;
} */

.flag[country="flag_8"] {
  /*denmark*/
  background-position: -48px -96px;
}

.flag[country="flag_807"] {
  /*fiji*/
  background-position: -48px -121px;
}

/* .flag[country='flag_134'] {
  background-position: -72px -96px;
} */

.flag[country="flag_18"] {
  background-position: -240px -266px;
}

.flag[country="flag_1024"] {
  /*dominicanrepublic*/
  background-position: -120px -96px;
}

.flag[country="flag_165"] {
  /*ecuador*/
  background-position: -144px -96px;
}

.flag[country="flag_305"] {
  /*egypt*/
  background-position: -168px -96px;
}

.flag[country="flag_89"] {
  /*england*/
  background-position: -216px -96px;
}

/* .flag[country='flag_141'] {
  background-position: -264px -96px;
} */

.flag[country="flag_92"] {
  /*estonia*/
  background-position: -288px -96px;
}

/* .flag[country='flag_39'] {
  background-position: -312px -96px;
} */

.flag[country="flag_europaleague"] {
  background-position: -336px -96px;
}

.flag[country="flag_europe"] {
  background-position: -360px -96px;
}

/* .flag[country='flag_146'] {
  background-position: -24px -120px;
} */

/* .flag[country='flag_144'] {
  background-position: -48px -120px;
} */

.flag[country="flag_19"] {
  /*finland*/
  background-position: -72px -120px;
}

.flag[country="flag_7"] {
  /*france*/
  background-position: -96px -120px;
}

/* .flag[country='flag_208'] {
  background-position: -120px -120px;
} */

/* .flag[country='flag_45'] {
  background-position: -144px -120px;
} */

.flag[country="flag_270"] {
  /*Georgia*/
  background-position: -168px -120px;
}

.flag[country="flag_30"] {
  /*germany*/
  background-position: -192px -120px;
}

.flag[country="flag_542"] {
  /*ghana*/
  background-position: -216px -120px;
}

/* .flag[country='flag_44'] {
  background-position: -240px -120px;
} */

/* .flag[country='flag_2'] {
  background-position: -264px -120px;
} */

.flag[country="flag_542"] {
  /*greece*/
  background-position: -288px -120px;
}

/* .flag[country='flag_210'] {
  background-position: -312px -120px;
} */

/* .flag[country='flag_41'] {
  background-position: -336px -120px;
} */

/* .flag[country='flag_46'] {
  background-position: -360px -120px;
} */

/* .flag[country='flag_51'] {
  background-position: 0 -144px;
} */

.flag[country="flag_365"] {
  /*guatemala*/
  background-position: -24px -144px;
}

.flag[country="flag_guernsey"] {
  background-position: -48px -144px;
}

/* .flag[country='flag_237'] {
  background-position: -72px -144px;
} */

/* .flag[country='flag_211'] {
  background-position: -96px -144px;
} */

/* .flag[country='flag_52'] {
  background-position: -120px -144px;
} */

/* .flag[country='flag_56'] {
  background-position: -144px -144px;
} */

.flag[country="flag_437"] {
  /*honduras*/
  background-position: -168px -144px;
}

/* .flag[country='flag_53'] {
  background-position: -192px -144px;
} */

.flag[country="flag_11"] {
  /*hungary*/
  background-position: -216px -144px;
}

.flag[country="flag_10"] {
  /*iceland*/
  background-position: -240px -144px;
}

.flag[country="flag_497"] {
  /*india*/
  background-position: -264px -144px;
}

/* .flag[country='flag_58'] {
  background-position: -288px -144px;
} */

.flag[country="flag_301"] {
  /*iran*/
  background-position: -336px -144px;
}

/* .flag[country='flag_214'] {
  background-position: -360px -144px;
} */

.flag[country="flag_51"] {
  /*Ireland*/
  background-position: 0 -168px;
}

.flag[country="flag_islamic-conference"] {
  background-position: -24px -168px;
}

.flag[country="flag_isle-of-man"] {
  background-position: -48px -168px;
}

.flag[country="flag_66"] {
  /*israel*/
  background-position: -72px -168px;
}

.flag[country="flag_31"] {
  /*italy*/
  background-position: -96px -168px;
}

/* .flag[country='flag_63'] {
  background-position: -120px -168px;
} */

.flag[country="flag_jersey"] {
  background-position: -144px -168px;
}

.flag[country="flag_329"] {
  /*jordan*/
  background-position: -168px -168px;
}

.flag[country="flag_278"] {
  /*kazakhstan*/
  background-position: -192px -168px;
}

.flag[country="flag_805"] {
  /*kenya*/
  background-position: -216px -168px;
}

/* .flag[country='flag_151'] {
  background-position: -240px -168px;
} */

/* .flag[country='flag_154'] {
  background-position: -264px -168px;
} */

.flag[country="flag_291"] {
  background-position: -288px -168px;
}

/* .flag[country='flag_253'] {
  background-position: -312px -168px;
} */

/* .flag[country='flag_155'] {
  background-position: -336px -168px;
} */

/* .flag[country='flag_150'] {
  background-position: -360px -168px;
} */

/* .flag[country='flag_157'] {
  background-position: 0 -192px;
} */

.flag[country="flag_163"] {
  /*latvia*/
  background-position: -24px -192px;
}

/* .flag[country='flag_158'] {
  background-position: -48px -192px;
} */

/* .flag[country='flag_127'] {
  background-position: -72px -192px;
} */

/* .flag[country='flag_liberia'] {
  background-position: -96px -192px;
} */

/* .flag[country='flag_130'] {
  background-position: -120px -192px;
} */

/* .flag[country='flag_67'] {
  background-position: -144px -192px;
} */

.flag[country="flag_160"] {
  /*lithuania*/
  background-position: -168px -192px;
}

.flag[country="flag_197"] {
  /*luxembourg*/
  background-position: -192px -192px;
}

/* .flag[country='flag_109'] {
  background-position: -216px -192px;
} */

/* .flag[country='flag_234'] {
  background-position: -240px -192px;
} */

/* .flag[country='flag_133'] {
  background-position: -264px -192px;
} */

/* .flag[country='flag_115'] {
  background-position: -288px -192px;
} */

.flag[country="flag_85"] {
  /*malaysia*/
  background-position: -312px -192px;
}

/* .flag[country='flag_114'] {
  background-position: -336px -192px;
} */

/* .flag[country='flag_106'] {
  background-position: -360px -192px;
} */

.flag[country="flag_134"] {
  /*malta*/
  background-position: 0 -216px;
}

/* .flag[country='flag_105'] {
  background-position: -24px -216px;
} */

/* .flag[country='flag_110'] {
  
  background-position: -48px -216px;
} */

/* .flag[country='flag_111'] {
  background-position: -72px -216px;
} */

/* .flag[country='flag_113'] {
  
  background-position: -96px -216px;
} */

.flag[country="flag_12"] {
  /*mexico*/
  background-position: -120px -216px;
}

/* .flag[country='flag_40'] {
  background-position: -144px -216px;
} */

.flag[country="flag_279"] {
  /*moldova*/
  background-position: -168px -216px;
}

/* .flag[country='flag_132'] {
  background-position: -192px -216px;
} */

/* .flag[country='flag_108'] {
  background-position: -216px -216px;
} */

.flag[country="flag_386"] {
  /*montenegro*/
  background-position: -240px -216px;
}

/* .flag[country='flag_112'] {
  background-position: -264px -216px;
} */

.flag[country="flag_303"] {
  /*morocco*/
  background-position: -288px -216px;
}

/* .flag[country='flag_117'] {
  background-position: -312px -216px;
} */

.flag[country="flag_107"] {
  background-position: -96px -168px;
}

.flag[country="flag_nato"] {
  background-position: -360px -216px;
}

/* .flag[country='flag_118'] {
  background-position: 0 -240px;
} */

/* .flag[country='flag_35'] {
  background-position: -24px -240px;
} */

/* .flag[country='flag_124'] {
  background-position: -48px -240px;
} */

/* .flag[country='flag_167'] {
  background-position: -72px -240px;
} */

.flag[country="flag_holland"],
.flag[country="flag_35"] {
  /*netherlands*/
  background-position: -96px -240px;
}

/* .flag[country='flag_33'] {
  background-position: -120px -240px;
} */

/* .flag[country='flag_126'] {
  background-position: -144px -240px;
} */

.flag[country="flag_389"] {
  /*nicaragua*/
  background-position: -168px -240px;
}

/* .flag[country='flag_532'] {
  background-position: -192px -240px;
} */

.flag[country="flag_532"] {
  /*nigeria*/
  background-position: -216px -240px;
}

/* .flag[country='flag_66'] {
  background-position: -240px -240px;
} */

.flag[country="flag_northamerica"] {
  background-position: -264px -240px;
}

.flag[country="flag_northern-cyprus"] {
  background-position: -288px -240px;
}

/* .flag[country='flag_241'] {
  background-position: -312px -240px;
} */

.flag[country="flag_5"] {
  /*norway*/
  background-position: -336px -240px;
}

.flag[country="flag_opec"] {
  background-position: -360px -240px;
}

.flag[country="flag_olimpic-movement"] {
  background-position: 0 -264px;
}

.flag[country="flag_olympicgames"] {
  background-position: -24px -264px;
}

.flag[country="flag_77"] {
  /*oman*/
  background-position: -48px -264px;
}

/* .flag[country='flag_21'] {
  background-position: -72px -264px;
} */

/* .flag[country='flag_77'] {
  background-position: -96px -264px;
} */

/* .flag[country='flag_246'] {
  
  background-position: -120px -264px;
} */

.flag[country="flag_526"] {
  /*panama*/
  background-position: -144px -264px;
}

/* .flag[country='flag_20'] {
  background-position: -168px -264px;
} */

.flag[country="flag_280"] {
  /*paraguay*/
  background-position: -192px -264px;
}

.flag[country="flag_20"] {
  /*peru*/
  background-position: -216px -264px;
}

/* .flag[country='flag_222'] {
  background-position: -240px -264px;
} */

.flag[country="flag_47"] {
  /*poland*/
  background-position: -264px -264px;
}

.flag[country="flag_44"] {
  /*Portugal*/
  background-position: -288px -264px;
}

/* .flag[country='flag_25'] {
  background-position: -312px -264px;
} */

/* .flag[country='flag_223'] {
  background-position: -336px -264px;
} */

.flag[country="flag_red-cross"] {
  background-position: -360px -264px;
}

.flag[country="flag_republicofireland"] {
  background-position: 0 -288px;
}

/* .flag[country='flag_256'] {
  background-position: -24px -288px;
} */

.flag[country="flag_77"] {
  /*romania*/
  background-position: -48px -288px;
}

.flag[country="flag_21"] {
  /*russia*/
  background-position: -72px -288px;
}

/* .flag[country='flag_26'] {
  background-position: -96px -288px;
} */

/* .flag[country='flag_159'] {
  background-position: -120px -288px;
} */

/* .flag[country='flag_224'] {
  background-position: -144px -288px;
} */

/* .flag[country='flag_88'] {
  background-position: -168px -288px;
} */

/* .flag[country='flag_91'] {
  background-position: -192px -288px;
} */

/* .flag[country='flag_80'] {
  background-position: -216px -288px;
} */

.flag[country="flag_22"] {
  /*scotland*/
  background-position: -240px -288px;
}

.flag[country="flag_886"] {
  /*senegal*/
  background-position: -264px -288px;
}

.flag[country="flag_152"] {
  /*serbia*/
  background-position: -288px -288px;
}

.flag[country="flag_seyshelles"] {
  background-position: -312px -288px;
}

/* .flag[country='flag_87'] {
  background-position: -336px -288px;
} */

.flag[country="flag_45"] {
  /*singapore*/
  background-position: -360px -288px;
}

.flag[country="flag_23"] {
  /*slovakia*/
  background-position: 0 -312px;
}

.flag[country="flag_24"] {
  /*slovenia*/
  background-position: -24px -312px;
}

/* .flag[country='flag_81'] {
  background-position: -48px -312px;
} */

/* .flag[country='flag_89'] {
  background-position: -72px -312px;
} */

.flag[country="flag_somaliland"] {
  background-position: -96px -312px;
}

/* .flag[country='flag_14'] {
  background-position: -120px -312px;
} */

.flag[country="flag_southkorea-copy"] {
  background-position: -144px -312px;
}

.flag[country="flag_southkorea"] {
  background-position: -168px -312px;
}

.flag[country="flag_32"] {
  /*spain*/
  background-position: -192px -312px;
}

/* .flag[country='flag_160'] {
  background-position: -216px -312px;
} */

/* .flag[country='flag_153'] {
  background-position: -240px -312px;
} */

/* .flag[country='flag_7'] {
  background-position: -264px -312px;
} */

/* .flag[country='flag_226'] {
  background-position: -288px -312px;
} */

/* .flag[country='flag_90'] {
  background-position: -312px -312px;
} */

/* .flag[country='flag_94'] {
  background-position: -336px -312px;
} */

.flag[country="flag_9"] {
  /*sweden*/
  background-position: -360px -312px;
}

.flag[country="flag_25"] {
  /*switzerland*/
  background-position: 0 -336px;
}

/* .flag[country='flag_93'] {
  background-position: -24px -336px;
} */

/* .flag[country='flag_tahiti-19'] {
  background-position: -48px -336px;
} */

/* .flag[country='flag_104'] {
  background-position: -72px -336px;
} */

/* .flag[country='flag_98'] {
  background-position: -96px -336px;
} */

.flag[country="flag_803"] {
  /*tanzania*/
  background-position: -120px -336px;
}

/* .flag[country='flag_30'] {
  background-position: -144px -336px;
} */

.flag[country="flag_timor-leste"] {
  background-position: -168px -336px;
}

.flag[country="flag_97"] {
  background-position: -73px -24px;
  /*Austria Amateur*/
}

.flag[country="flag_148"] {
  background-position: -143px -236px;
  /*Neazland*/
}

.flag[country="flag_366"] {
  background-position: -361px -358px;
  /* Vietnam */
}

.flag[country="flag_815"] {
  background-position: -168px -385px;
  /* Zimbabwe */
}

.flag[country="flag_490"] {
  background-position: -360px -143px;
  /* iraq */
}
.flag[country="flag_502"] {
  background-position: -121px -169px;
  /* jamaica */
}
.flag[country="flag_512"] {
  background-position: -360px -143px;
  /* Liechtenstein */
}

.flag[country="flag_527"] {
  background-position: -265px -337px;
  /* Trinidad and Tobago */
}

.flag[country="flag_99000086"] {
  background-position: -312px -291px;
  /* Seychelless */
}

.flag[country="flag_99000059"] {
  background-position: -313px -265px;
  /* Puerto Rico */
}

.flag[country="flag_1000157"] {
  background-position: -1px -26px;
  /* Aruba */
}

.flag[country="flag_847"] {
  background-position: -241px -266px;
  /* phillipeans */
}

.flag[country="flag_951"] {
  background-position: -241px -266px;
  /* Rwanda */
}

.flag[country="flag_1031"] {
  background-position: -119px -95px;
  /* Dominican Republic */
}

.flag[country="flag_1000150"] {
  background-position: -119px -95px;
  /* Gambia */
}
.flag[country="flag_99000102"] {
  background-position: -73px -95px;
  /* Djibouti  */
}

.flag[country="flag_773"] {
  background-position: -192px -217px;
  /* mocao */
}

.flag[country="flag_792"] {
  background-position: -192px -217px;
  /* Barbados */
}

.flag[country="flag_829"] {
  background-position: -289px -193px;
  /* Malawi */
}
.flag[country="flag_600"] {
  background-position: -335px -193px;
  /* Maldives  */
}

.flag[country="flag_1360"] {
  background-position: -95px -47px;
  /* Brunei Darussalam    */
}

.flag[country="flag_1000275"] {
  background-position: -24px -24px;
  /* North & Central America    */
}

.flag[country="flag_99000068"] {
  background-position: -239px -384px;
  /* Internazional Women   */
}

.flag[country="flag_181"] {
  background-position: 0px 0px;
  /* Hopman Cup  */
}

.flag[country="flag_74"] {
  background-position: -173px -405px;
  /* Federation Cup  */
}

.flag[country="flag_1000262"] {
  background-position: -359px -72px;
  /* Cuba  */
}
.flag[country="flag_99000106"] {
  background-position: -240px -24px;

  /* Belgium Amateur  */
}

.flag[country="flag_1000369"] {
  background-position: -95px -193px;
  /* Liberia  */
}

.flag[country="flag_99000008"] {
  background-position: -239px -193px;
  /* North Macedonia  */
}
.flag[country="flag_1000306"] {
  background-position: -313px -218px;
  /* Muritania  */
}

.flag[country="flag_806"] {
  background-position: -72px -218px;
  /* Mozambique  */
}

.flag[country="flag_1000207"] {
  background-position: -264px -168px;
  /* South Korea  */
}
.flag[country="flag_99000128"] {
  background-position: -240px -311px;
  /* Saint Kitts & Nevis  */
}

.flag[country="flag_1000174"] {
  background-position: -72px -72px;
  /* Taiwan  */
}

.flag[country="flag_1000202"] {
  background-position: -312px -72px;
  /* Republic of Ireland  */
}
.flag[country="flag_944"] {
  background-position: -288px -0px;
  /* Antigua and Barbuda  */
}

.flag[country="flag_905"] {
  background-position: -47px -242px;
  /* Nepal  */
}

.flag[country="flag_99000018"] {
  background-position: -0px -242px;
  /* Namibia  */
}

.flag[country="flag_790"] {
  background-position: -265px -291px;
  /* Myanmar */
}

.flag[country="flag_804"] {
  background-position: -46px -49px;
  /* botsawana */
}

.flag[country="flag_158"] {
  background-position: -22px -49px;
  /* Bosnia & Herzegovina */
}

.flag[country="flag_1000346"] {
  background-position: -144px -49px;
  /* Burkina Faso */
}

.flag[country="flag_1000249"] {
  background-position: -24px -73px;
  /* Mali */
}

.flag[country="flag_380"] {
  background-position: -24px -337px;
  /* syrian arab */
}

.flag[country="flag_390"] {
  background-position: -313px -69px;
  /* ivory coast */
}

/* .flag[country='flag_227'] {
  background-position: -216px -336px;
} */

/* .flag[country='flag_228'] {
  background-position: -240px -336px;
} */

.flag[country="flag_trinidadandtobago"] {
  background-position: -264px -336px;
}

.flag[country="flag_378"] {
  /*tunisia*/
  background-position: -288px -336px;
}

.flag[country="flag_46"] {
  /*turkey*/
  background-position: -312px -336px;
}

/* .flag[country='flag_100'] {
  background-position: -336px -336px;
} */

/* .flag[country='flag_29'] {
  background-position: -360px -336px;
} */

/* .flag[country='flag_31'] {
  background-position: 0 -360px;
} */

/* .flag[country='flag_163'] {
  background-position: -24px -360px;
} */

.flag[country="flag_1"] {
  background-position: -48px -360px;
}

.flag[country="flag_26"] {
  /*usa*/
  background-position: -72px -360px;
}

.flag[country="flag_86"] {
  /*ukraine*/
  background-position: -120px -360px;
}

.flag[country="flag_united-nations"] {
  background-position: -144px -360px;
}

.flag[country="flag_unitedarabemirates"] {
  background-position: -168px -360px;
}

.flag[country="flag_unitedkingdom"] {
  background-position: -192px -360px;
}

.flag[country="flag_57"] {
  /*uruguay*/
  background-position: -216px -360px;
}

/* .flag[country='flag_5'] {
  background-position: -240px -360px;
} */

.flag[country="flag_vtb"] {
  background-position: -264px -360px;
}

/* .flag[country='flag_10'] {
  background-position: -288px -360px;
} */

.flag[country="flag_vatican-city"] {
  background-position: -312px -360px;
}

.flag[country="flag_281"] {
  /*venezuela*/
  background-position: -336px -360px;
}

/* .flag[country='flag_9'] {
  background-position: -360px -360px;
} */

/* .flag[country='flag_8'] {
  background-position: 0 -384px;
} */

/* .flag[country='flag_235'] {
  background-position: -24px -384px;
} */

.flag[country="flag_131"] {
  /*wales*/
  background-position: -48px -384px;
}

/* .flag[country='flag_140'] {
  background-position: -72px -384px;
} */

/* .flag[country='flag_232'] {
  background-position: -120px -384px;
} */

/* .flag[country='flag_233'] {
  background-position: -144px -384px;
} */

/* .flag[country='flag_16'] {
  background-position: -168px -384px;
} */

.flag[country="flag_52"] {
  /*japan*/
  background-position: -192px -384px;
}

.flag[country="flag_rolandgarros"] {
  background-position: -216px -384px;
}

.flag[country="flag_undefined"] {
  background-position: -240px -384px;
}

.flag[country="flag_wimbledon"] {
  background-position: -264px -384px;
}

.flag[country="flag_bundesliga"] {
  background-position: -197px -406px;
}

.flag[country="flag_102"] {
  background-position: 0px -94px;
}

.flag[country="flag_252"] {
  background-position: -192px -360px;
}

.flag[country="flag_122"] {
  background-position: -191px -122px;
}

.flag[country="flag_67"] {
  background-position: -287px -122px;
}

.flag[country="flag_565"] {
  background-position: -310px -171px;
}

.flag[country="flag_130"] {
  background-position: -312px -237px;
}

.flag[country="flag_2123"] {
  background-position: 0px -122px;
}

.flag[country="flag_103"] {
  background-position: -95px -383px;
}

.flag[country="flag_828"] {
  background-position: -71px -73px;
}

.flag[country="flag_549"] {
  background-position: -216px -358px;
}

.flag[country="flag_2157"] {
  background-position: 0px -122px;
}

.flag[country="flag_3"] {
  background-position: 0px 0px;
}

.flag[country="flag_785"] {
  background-position: -48px -406px;
}

.flag[country="flag_6"] {
  background-position: 0px -406px;
}

.flag[country="flag_871"] {
  background-position: 0px -406px;
}

.flag[country="flag_27"] {
  background-position: -95px -383px;
}

.flag[country="flag_136"] {
  background-position: -95px -383px;
}

.flag[country="flag_15"] {
  background-position: -144px 0px;
}

.flag[country="flag_213"] {
  background-position: -48px -406px;
}

.flag[country="flag_297"] {
  background-position: -96px -21px;
}

.flag[country="flag_289"] {
  background-position: -287px -69px;
}

.flag[country="flag_95"] {
  background-position: -48px -96px;
}

.flag[country="flag_201"] {
  background-position: -23px -122px;
}

.flag[country="flag_159"] {
  background-position: -240px -190px;
}

.flag[country="flag_299"] {
  background-position: -167px -361px;
}

.flag[country="flag_2158"] {
  background-position: 0px -122px;
}

.flag[country="flag_72"] {
  background-position: -337px -385px;
}

.flag[country="flag_79"] {
  background-position: -336px -384px;
}

.flag[country="flag_262"] {
  background-position: -71px -290px;
}

.flag[country="flag_157"] {
  background-position: -71px -290px;
}

.flag[country="flag_1525"] {
  background-position: -216px -122px;
}

.flag[country="flag_447"] {
  background-position: -263px -170px;
}

.flag[country="flag_laliga"] {
  background-position: -222px -406px;
  transform: scale(1);
}

.flag[country="super-lig"] {
  background-position: -244px -406px;
  transform: scale(1);
}

.flag[country="premier-lig"] {
  background-position: -265px -408px;
  transform: scale(1);
}

.flag[country="serie"] {
  background-position: -288px -408px;
  transform: scale(1);
}

.flag[country="nba"] {
  background-position: -308px -408px;
  transform: scale(1);
}

.flag[country="ufc"] {
  background-position: -332px -408px;
  transform: scale(1);
}

.flag[country="flag_351"] {
  background-position: -143px -22px;
}

.flag[country="flag_367"] {
  background-position: -168px -239px;
}

.flag[country="flag_755"] {
  background-position: -71px -262px;
}

.flag[country="flag_56"] {
  background-position: -95px -383px;
}

.flag[country="flag_37"] {
  /*usa*/
  background-position: -72px -360px;
}

.flag[country="flag_39"] {
  /*sweden*/
  background-position: -360px -312px;
}

.flag[country="flag_101"] {
  /*russia*/
  background-position: -72px -288px;
}

.flag[country="flag_42"] {
  background-position: -240px -266px;
}

.flag[country="flag_368"] {
  background-position: -287px -145px;
}

.flag[country="flag_34"] {
  /*australia*/
  background-position: -48px -24px;
}

.flag[country="flag_64"] {
  /*denmark*/
  background-position: -48px -96px;
}

.flag[country="flag_392"] {
  /*international*/
  background-position: -239px -384px;
}

.flag[country="flag_284"] {
  /*poland*/
  background-position: -264px -264px;
}

.flag[country="flag_41"] {
  /*germany*/
  background-position: -192px -120px;
}

.flag[country="flag_275"] {
  /*belarus*/
  background-position: -216px -24px;
}

.flag[country="flag_40"] {
  /*finland*/
  background-position: -72px -120px;
}

.flag[country="flag_54"] {
  /*switzerland*/
  background-position: 0 -336px;
}

.flag[country="flag_539"] {
  /*Philippines*/
  background-position: -240px -267px;
}

.flag[country="flag_155"] {
  /*sweden*/
  background-position: -360px -312px;
}

.flag[country="flag_421"] {
  /*spain*/
  background-position: -192px -312px;
}

.flag[country="flag_485"] {
  /*thailand*/
  background-position: -288px -75px;
}

.flag[country="flag_254"] {
  /*turkey*/
  background-position: -312px -336px;
}

.flag[country="flag_107"] {
  /*italy*/
  background-position: -96px -168px;
}

.flag[country="flag_395"] {
  /*mexico*/
  background-position: -120px -216px;
}

.flag[country="flag_306"] {
  /*latvia*/
  background-position: -24px -192px;
}

.flag[country="flag_98"] {
  /*slovakia*/
  background-position: 0 -312px;
}

.flag[country="flag_1043"] {
  /*bhutan*/
  background-position: -335px -23px;
}

.flag[country="flag_956"] {
  /*burundi*/
  background-position: -168px -46px;
}

.flag[country="flag_827"] {
  /*curacao*/
  background-position: -23px -242px;
}

.flag[country="flag_352"] {
  /*india*/
  background-position: -264px -144px;
}

.flag[country="flag_787"] {
  /*kyrgyzstan*/
  background-position: -360px -165px;
}

.flag[country="flag_1042"] {
  /*mongolia*/
  background-position: -216px -215px;
}

.flag[country="flag_353"] {
  /*Qatar*/
  background-position: -336px -266px;
}

.flag[country="flag_111"] {
  /*germany*/
  background-position: -192px -120px;
}

.flag[country="flag_109"] {
  /*spain*/
  background-position: -192px -312px;
}

.flag[country="flag_110"] {
  /*france*/
  background-position: -96px -120px;
}

.flag[country="flag_263"] {
  /*brazil*/
  background-position: -72px -48px;
}

.flag[country="flag_108"] {
  /*greece*/
  background-position: -288px -120px;
}

.flag[country="flag_784"] {
  /*hong kong*/
  background-position: -192px -143px;
}

.flag[country="flag_844"] {
  /*Puerto Rica*/
  background-position: -311px -266px;
}

.flag[country="flag_814"] {
  /*usa*/
  background-position: -72px -360px;
}

.flag[country="flag_373"] {
  /*brazil*/
  background-position: -72px -48px;
}

.flag[country="flag_123"] {
  /*germany*/
  background-position: -192px -120px;
}

.flag[country="flag_810"] {
  /*kazakhstan*/
  background-position: -192px -168px;
}

.flag[country="flag_38"] {
  /*norway*/
  background-position: -336px -240px;
}
.flag[country="flag_115"] {
  /*poland*/
  background-position: -264px -264px;
}
.flag[country="flag_331"] {
  /*kuwait*/
  background-position: -336px -171px;
}

.flag[country="flag_428"] {
  /*lebanon*/
  background-position: -47px -194px;
}

.flag[country="flag_387"] {
  /*San Marino*/
  background-position: -168px -288px;
}
.flag[country="flag_540"] {
  /*Palestine*/
  background-position: -120px -263px;
}

.flag[country="flag_188"] {
  /*israel*/
  background-position: -72px -168px;
}
.flag[country="flag_65"] {
  /*austria*/
  background-position: -72px -24px;
}
.flag[country="flag_546"] {
  /*iceland*/
  background-position: -240px -144px;
}

.flag[country="flag_339"] {
  /*hong kong*/
  background-position: -192px -143px;
}

.flag[country="flag_190"] {
  /*croatia*/
  background-position: -336px -72px;
}

.flag[country="flag_1017"],
.flag[country="flag_154"] {
  /*czech republic*/
  background-position: -23px -97px;
}
.flag[country="flag_168"] {
  /*lithuania*/
  background-position: -168px -192px;
}

.flag[country="flag_76"] {
  /*davis cup*/
  background-position: -123px -407px;
}
.flag[country="flag_285"] {
  /*hungary*/
  background-position: -216px -144px;
}
.flag[country="flag_242"] {
  /*france*/
  background-position: -96px -120px;
}

.flag[country="flag_244"] {
  /*denmark*/
  background-position: -48px -96px;
}

.flag[country="flag_112"] {
  /*turkey*/
  background-position: -312px -336px;
}
.flag[country="flag_106"] {
  /*norway*/
  background-position: -336px -240px;
}
.flag[country="flag_328"] {
  /*netherlands*/
  background-position: -96px -240px;
}
.flag[country="flag_189"] {
  /*belgium*/
  background-position: -240px -24px;
}

.flag[country="flag_114"] {
  /*sweden*/
  background-position: -360px -312px;
}

.flag[country="flag_267"] {
  /*ukraine*/
  background-position: -120px -360px;
}
.flag[country="flag_948"] {
  /*tunisia*/
  background-position: -288px -336px;
}
.flag[country="flag_176"] {
  /*canada*/
  background-position: -312px -48px;
}

.flag[country="flag_135"] {
  /*finland*/
  background-position: -72px -120px;
}

.flag[country="flag_287"] {
  /*Portugal*/
  background-position: -288px -264px;
}

.flag[country="flag_149"] {
  /*finland*/
  background-position: -72px -120px;
}

.flag[country="flag_548"] {
  /*china*/
  background-position: -96px -72px;
}

.flag[country="flag_176"] {
  /*canada*/
  background-position: -312px -48px;
}

.flag[country="flag_126"] {
  /*italy*/
  background-position: -96px -168px;
}
.flag[country="flag_135"] {
  /*finland*/
  background-position: -72px -120px;
}

.flag[country="flag_177"] {
  /*sweden*/
  background-position: -360px -312px;
}
.flag[country="flag_179"] {
  /*greece*/
  background-position: -288px -120px;
}

.flag[country="flag_256"] {
  /*belgium*/
  background-position: -240px -24px;
}

.flag[country="flag_313"] {
  /*poland*/
  background-position: -264px -264px;
}
.flag[country="flag_398"] {
  /*romania*/
  background-position: -48px -288px;
}
.flag[country="flag_457"] {
  /*slovakia*/
  background-position: 0 -312px;
}
.flag[country="flag_415"] {
  /*oman*/
  background-position: -48px -264px;
}
.flag[country="flag_180"] {
  /*france*/
  background-position: -96px -120px;
}

.flag[country="flag_312"] {
  /*switzerland*/
  background-position: 0 -336px;
}

.flag[country="flag_812"] {
  /*zambia*/
  background-position: -144px -386px;
}

.flag[country="flag_824"] {
  /*uganda*/
  background-position: -95px -362px;
}

.flag[country="flag_938"] {
  /*gibraltar*/
  background-position: -239px -118px;
}
.flag[country="flag_372"] {
  /*bulgaria*/
  background-position: -120px -48px;
}

.flag[country="flag_307"] {
  /*england*/
  background-position: -216px -96px;
}

.flag[country="flag_195"] {
  /*turkey*/
  background-position: -312px -336px;
}
.flag[country="flag_129"] {
  /*spain*/
  background-position: -192px -312px;
}
.flag[country="flag_146"] {
  /*netherlands*/
  background-position: -96px -240px;
}
.flag[country="flag_265"] {
  /*Portugal*/
  background-position: -288px -264px;
}
.flag[country="flag_128"] {
  /*austria*/
  background-position: -72px -24px;
}
.flag[country="flag_138"] {
  /*switzerland*/
  background-position: 0 -336px;
}

.flag[country="flag_171"] {
  /*norway*/
  background-position: -336px -240px;
}
.flag[country="flag_196"] {
  /*czech republic*/
  background-position: -23px -97px;
}
.flag[country="flag_199"] {
  /*denmark*/
  background-position: -48px -96px;
}

.flag[country="flag_283"] {
  /*croatia*/
  background-position: -336px -72px;
}
.flag[country="flag_608"] {
  /*aruba*/
  background-position: 0px -23px;
}

.flag[country="flag_257"] {
  /*albania*/
  background-position: -95px 0px;
}

.flag[country="flag_914"] {
  /*ethiopia*/
  background-position: -312px -98px;
}

.flag[country="flag_117"] {
  /*england*/
  background-position: -216px -96px;
}
.flag[country="flag_483"] {
  /*japan*/
  background-position: -192px -384px;
}

.flag[country="flag_1451"] {
  /*kosovo*/
  background-position: -313px -167px;
}

.flag[country="flag_376"] {
  /*andorra*/
  background-position: -192px 0px;
}
.flag[country="flag_258"] {
  /*latvia*/
  background-position: -24px -192px;
}
.flag[country="flag_324"] {
  /*romania*/
  background-position: -48px -288px;
}
.flag[country="flag_288"] {
  /*serbia*/
  background-position: -288px -288px;
}

.flag[country="flag_771"] {
  /*china*/
  background-position: -96px -72px;
}

.flag[country="flag_561"] {
  /*japan*/
  background-position: -192px -384px;
}

.flag[country="flag_340"] {
  /*serbia*/
  background-position: -288px -288px;
}
.flag[country="flag_375"] {
  background-position: -168px -312px;
}

.flag[country="flag_747"] {
  background-position: -240px -188px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Flags.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yDAAuD;EACvD,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAoDE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAEhC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EAQE,iCAAiC;AANnC;;AASA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;GAEG;;AAEH;;;;;EAKE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;;;;;;;;;AAUA;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;;;EAIE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;;EAWE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;;;;;;;;;EAWE,UAAU;EACV,gCAAgC;AAClC;;AAEA;;;;EAIE,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,iCAAiC;AACnC;;AAEA;;;;;;;;;;;;EAYE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;;;EAIE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;;;EAIE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;;;;;;;;EASE,SAAS;EACT,gCAAgC;AAClC;;AAEA;;;;;;EAME,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,iCAAiC;AACnC;;AAEA;;;;EAIE,WAAW;EACX,iCAAiC;AACnC;;AAEA;;;;;;EAME,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,QAAQ;EACR,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,QAAQ;EACR,gCAAgC;AAClC;;AAEA;;;;EAIE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;;;GAGG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,OAAO;EACP,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;;;GAGG;;AAEH;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;EAEE,cAAc;EACd,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;;GAGG;;AAEH;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,iCAAiC;;EAEjC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;EACE,MAAM;EACN,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,QAAQ;EACR,iCAAiC;AACnC;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,MAAM;EACN,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,MAAM;EACN,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,OAAO;EACP,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".flag {\n  display: inline-block;\n  vertical-align: middle;\n  width: 24px;\n  height: 24px;\n  background-image: url(\"../../public/images/flags.webp\");\n  background-repeat: no-repeat;\n  background-position: 100px 0;\n  transform: scale(0.8);\n  transform-origin: left center;\n}\n\n.flag[country=\"flag_home\"] {\n  background-image: none;\n}\n\n/* .flag[country='flag_worldcup'] {\n  background-position: -287px -384px;\n} */\n\n.flag[country=\"flag_4\"],\n.flag[country=\"flag_4\"],\n.flag[country=\"flag_103\"],\n.flag[country=\"flag_225\"],\n.flag[country=\"flag_56\"],\n.flag[country=\"flag_1000408\"],\n.flag[country=\"flag_73\"],\n.flag[country=\"flag_80\"],\n.flag[country=\"flag_27\"],\n.flag[country=\"flag_1718\"],\n.flag[country=\"flag_1000329\"],\n.flag[country=\"flag_120\"],\n.flag[country=\"flag_777\"],\n.flag[country=\"flag_96\"],\n.flag[country=\"flag_55\"],\n.flag[country=\"flag_88\"],\n.flag[country=\"flag_105\"],\n.flag[country=\"flag_104\"],\n.flag[country=\"flag_136\"],\n.flag[country=\"flag_166\"],\n.flag[country=\"flag_161\"],\n.flag[country=\"flag_164\"],\n.flag[country=\"flag_178\"],\n.flag[country=\"flag_250\"],\n.flag[country=\"flag_259\"],\n.flag[country=\"flag_266\"],\n.flag[country=\"flag_290\"],\n.flag[country=\"flag_295\"],\n.flag[country=\"flag_371\"],\n.flag[country=\"flag_446\"],\n.flag[country=\"flag_504\"],\n.flag[country=\"flag_577\"],\n.flag[country=\"flag_756\"],\n.flag[country=\"flag_2025\"],\n.flag[country=\"flag_1038\"],\n.flag[country=\"flag_2030\"],\n.flag[country=\"flag_992\"],\n.flag[country=\"flag_990\"],\n.flag[country=\"flag_2033\"],\n.flag[country=\"flag_1495\"],\n.flag[country=\"flag_2037\"],\n.flag[country=\"flag_2038\"],\n.flag[country=\"flag_993\"],\n.flag[country=\"flag_850\"],\n.flag[country=\"flag_987\"],\n.flag[country=\"flag_96\"],\n.flag[country=\"flag_2082\"],\n.flag[country=\"flag_1715\"],\n.flag[country=\"flag_1731\"],\n.flag[country=\"flag_1780\"],\n.flag[country=\"flag_2032\"],\n.flag[country=\"flag_393\"] {\n  /*international*/\n  background-position: -239px -384px;\n}\n\n.flag[country=\"flag_uefachampionsleague\"] {\n  background-position: -47px -72px;\n  -webkit-filter: invert(0);\n  filter: invert(0);\n}\n\n.flag[country=\"flag_uefaeuropaleague\"] {\n  background-position: -336px -96px;\n}\n\n.flag[country=\"flag_copaamericacnt\"] {\n  background-position: -264px -72px;\n  width: 24px;\n  height: 24px;\n  margin-left: 10px;\n}\n\n.flag[country=\"flag_wta\"] {\n  background-position: -1px -405px;\n}\n\n.flag[country=\"flag_\"] {\n  background-position: -25px -405px;\n}\n.flag[country=\"flag_\"] {\n  background-position: -25px -405px;\n}\n\n.flag[country=\"flag_\"] {\n  background-position: -25px -405px;\n}\n\n.flag[country=\"flag_itf\"] {\n  background-position: -50px -405px;\n  transform: scale(0.8);\n}\n\n.flag[country=\"flag_challenger\"] {\n  background-position: -74px -405px;\n}\n\n.flag .flag[country=\"flag_daviscup\"] {\n  background-position: -149px -405px;\n}\n\n.flag[country=\"flag_fedcup\"] {\n  background-position: -173px -405px;\n}\n\n.flag[country=\"flag_euro\"] {\n  background-position: -336px -385px;\n}\n\n.flag[country=\"flag_asean\"] {\n  background-position: 0 0;\n}\n\n.flag[country=\"flag_310\"] {\n  background-position: -216px -291px;\n}\n\n.flag[country=\"flag_322\"] {\n  background-position: -120px -315px;\n}\n\n.flag[country=\"flag_african-union-oas\"] {\n  background-position: -72px 0;\n}\n\n/* .flag[country='flag_166'] {\n  background-position: -96px 0;\n} */\n\n.flag[country=\"flag_304\"],\n.flag[country=\"flag_304\"],\n.flag[country=\"flag_1000318\"],\n.flag[country=\"flag_1000277\"],\n.flag[country=\"flag_1000143\"] {\n  /*algeria*/\n  background-position: -120px 0;\n}\n\n.flag[country=\"flag_america\"],\n.flag[country=\"flag_26\"],\n.flag[country=\"flag_15\"],\n.flag[country=\"flag_16\"],\n.flag[country=\"flag_37\"],\n.flag[country=\"flag_43\"],\n.flag[country=\"flag_814\"],\n.flag[country=\"flag_988\"],\n.flag[country=\"flag_450\"],\n.flag[country=\"flag_1713\"] {\n}\n\n.flag[country=\"flag_500\"] {\n  /*angola*/\n  background-position: -216px 0;\n}\n\n.flag[country=\"flag_385\"] {\n  background-position: -72px -3px;\n}\n\n.flag[country=\"flag_arab-league\"] {\n  background-position: -312px 0;\n}\n\n.flag[country=\"flag_48\"],\n.flag[country=\"flag_264\"],\n.flag[country=\"flag_99000066\"],\n.flag[country=\"flag_1000175\"],\n.flag[country=\"flag_374\"],\n.flag[country=\"flag_1000237\"],\n.flag[country=\"flag_99000097\"] {\n  /*argentina*/\n  background-position: -336px 0;\n}\n\n.flag[country=\"flag_296\"],\n.flag[country=\"flag_296\"],\n.flag[country=\"flag_1000300\"],\n.flag[country=\"flag_2113\"] {\n  /*armenia*/\n  background-position: -360px 0;\n}\n\n.flag[country=\"flag_asia\"] {\n  background-position: -24px -24px;\n}\n\n.flag[country=\"flag_34\"],\n.flag[country=\"flag_34\"],\n.flag[country=\"flag_113\"],\n.flag[country=\"flag_775\"],\n.flag[country=\"flag_878\"],\n.flag[country=\"flag_87\"],\n.flag[country=\"flag_1723\"],\n.flag[country=\"flag_491\"],\n.flag[country=\"flag_1000307\"],\n.flag[country=\"flag_99000104\"],\n.flag[country=\"flag_99000142\"] {\n  /*australia*/\n  background-position: -48px -24px;\n}\n\n.flag[country=\"flag_17\"],\n.flag[country=\"flag_17\"],\n.flag[country=\"flag_170\"],\n.flag[country=\"flag_65\"],\n.flag[country=\"flag_99000044\"],\n.flag[country=\"flag_69\"],\n.flag[country=\"flag_128\"],\n.flag[country=\"flag_1000358\"],\n.flag[country=\"flag_99000015\"]\n  .flag[country=\"flag_97\"]\n  .flag[country=\"flag_1000341\"] {\n  /*austria*/\n  background-position: -72px -24px;\n}\n\n.flag[country=\"flag_173\"],\n.flag[country=\"flag_297\"],\n.flag[country=\"flag_1000314\"],\n.flag[country=\"flag_1000374\"] {\n  /*azerbaijan*/\n  background-position: -96px -24px;\n}\n\n.flag[country=\"flag_469\"],\n.flag[country=\"flag_834\"] {\n  /*bangladesh*/\n  background-position: -168px -24px;\n}\n\n.flag[country=\"flag_91\"],\n.flag[country=\"flag_91\"],\n.flag[country=\"flag_1000271\"],\n.flag[country=\"flag_275\"],\n.flag[country=\"flag_1000405\"],\n.flag[country=\"flag_400\"],\n.flag[country=\"flag_1000266\"],\n.flag[country=\"flag_99000095\"],\n.flag[country=\"flag_750\"],\n.flag[country=\"flag_1000294\"],\n.flag[country=\"flag_741\"],\n.flag[country=\"flag_1000161\"] {\n  /*belarus*/\n  background-position: -216px -24px;\n}\n\n.flag[country=\"flag_33\"],\n.flag[country=\"flag_189\"],\n.flag[country=\"flag_256\"],\n.flag[country=\"flag_1000359\"] {\n  /*belgium*/\n  background-position: -240px -24px;\n}\n\n.flag[country=\"flag_379\"],\n.flag[country=\"flag_99000025\"],\n.flag[country=\"flag_1525\"],\n.flag[country=\"flag_99000129\"] {\n  /*bolivia*/\n  background-position: -360px -24px;\n}\n\n.flag[country=\"flag_95\"]\n/* Austra Ametuer */\n\n\n.flag[country=\"flag_158\"] {\n  background-position: 0 -48px;\n}\n\n.flag[country=\"flag_13\"],\n.flag[country=\"flag_263\"],\n.flag[country=\"flag_1000146\"],\n.flag[country=\"flag_2152\"],\n.flag[country=\"flag_373\"],\n.flag[country=\"flag_1000166\"],\n.flag[country=\"flag_202\"],\n.flag[country=\"flag_99000139\"],\n.flag[country=\"flag_772\"] {\n  /*brazil*/\n  background-position: -72px -48px;\n}\n\n.flag[country=\"flag_78\"],\n.flag[country=\"flag_78\"],\n.flag[country=\"flag_372\"],\n.flag[country=\"flag_1000297\"],\n.flag[country=\"flag_332\"],\n.flag[country=\"flag_99000004\"] {\n  /*bulgaria*/\n  background-position: -120px -48px;\n}\n\n.flag[country=\"flag_caricom\"] {\n  background-position: -192px -48px;\n}\n\n.flag[country=\"flag_cis\"] {\n  background-position: -216px -48px;\n}\n\n.flag[country=\"flag_852\"],\n.flag[country=\"flag_1000235\"] {\n  /*cambodia*/\n  background-position: -240px -48px;\n}\n\n.flag[country=\"flag_391\"],\n.flag[country=\"flag_1805\"],\n.flag[country=\"flag_1000394\"],\n.flag[country=\"flag_99000023\"] {\n  /*cameroon*/\n  background-position: -288px -48px;\n}\n\n.flag[country=\"flag_388\"],\n.flag[country=\"flag_388\"],\n.flag[country=\"flag_876\"],\n.flag[country=\"flag_176\"],\n.flag[country=\"flag_93\"],\n.flag[country=\"flag_99000149\"] {\n  /*canada*/\n  background-position: -312px -48px;\n}\n\n.flag[country=\"flag_championsleague\"] {\n  background-position: -48px -72px;\n}\n\n.flag[country=\"flag_49\"],\n.flag[country=\"flag_828\"],\n.flag[country=\"flag_1000246\"] {\n  /*chile*/\n  background-position: -72px -72px;\n}\n\n.flag[country=\"flag_99\"],\n.flag[country=\"flag_548\"],\n.flag[country=\"flag_1000220\"],\n.flag[country=\"flag_718\"],\n.flag[country=\"flag_1000416\"],\n.flag[country=\"flag_771\"],\n.flag[country=\"flag_99000131\"] {\n  /*china*/\n  background-position: -96px -72px;\n}\n\n.flag[country=\"flag_274\"],\n.flag[country=\"flag_1000283\"],\n.flag[country=\"flag_99000030\"],\n.flag[country=\"flag_99000090\"] {\n  /*colombia*/\n  background-position: -120px -72px;\n}\n\n.flag[country=\"flag_commonwealth\"] {\n  background-position: -144px -72px;\n}\n\n.flag[country=\"flag_351\"] {\n  background-position: -144px -27px;\n}\n\n.flag[country=\"flag_367\"] {\n  background-position: -168px -243px;\n}\n\n.flag[country=\"flag_755\"] {\n  background-position: -71px -266px;\n}\n\n.flag[country=\"flag_congo-brazzaville\"] {\n  background-position: -192px -72px;\n}\n\n.flag[country=\"flag_congo-kinshasa\"] {\n  background-position: -216px -72px;\n}\n\n/* .flag[country='flag_194'] {\n  background-position: -240px -72px;\n} */\n\n.flag[country=\"flag_copaamerica\"] {\n  background-position: -264px -72px;\n}\n\n/* .flag[country='flag_198'] {\n  \n  background-position: -288px -72px;\n} */\n\n.flag[country=\"flag_cote-divoire\"] {\n  background-position: -312px -72px;\n}\n\n.flag[country=\"flag_14\"] {\n  /*croatia*/\n  background-position: -336px -72px;\n}\n\n/* .flag[country='flag_199'] {\n  background-position: -360px -72px;\n} */\n\n/* .flag[country='flag_75'] {\n  background-position: 0 -96px;\n} */\n\n/* .flag[country='flag_202'] {\n  background-position: -24px -96px;\n} */\n\n.flag[country=\"flag_8\"] {\n  /*denmark*/\n  background-position: -48px -96px;\n}\n\n.flag[country=\"flag_807\"] {\n  /*fiji*/\n  background-position: -48px -121px;\n}\n\n/* .flag[country='flag_134'] {\n  background-position: -72px -96px;\n} */\n\n.flag[country=\"flag_18\"] {\n  background-position: -240px -266px;\n}\n\n.flag[country=\"flag_1024\"] {\n  /*dominicanrepublic*/\n  background-position: -120px -96px;\n}\n\n.flag[country=\"flag_165\"] {\n  /*ecuador*/\n  background-position: -144px -96px;\n}\n\n.flag[country=\"flag_305\"] {\n  /*egypt*/\n  background-position: -168px -96px;\n}\n\n.flag[country=\"flag_89\"] {\n  /*england*/\n  background-position: -216px -96px;\n}\n\n/* .flag[country='flag_141'] {\n  background-position: -264px -96px;\n} */\n\n.flag[country=\"flag_92\"] {\n  /*estonia*/\n  background-position: -288px -96px;\n}\n\n/* .flag[country='flag_39'] {\n  background-position: -312px -96px;\n} */\n\n.flag[country=\"flag_europaleague\"] {\n  background-position: -336px -96px;\n}\n\n.flag[country=\"flag_europe\"] {\n  background-position: -360px -96px;\n}\n\n/* .flag[country='flag_146'] {\n  background-position: -24px -120px;\n} */\n\n/* .flag[country='flag_144'] {\n  background-position: -48px -120px;\n} */\n\n.flag[country=\"flag_19\"] {\n  /*finland*/\n  background-position: -72px -120px;\n}\n\n.flag[country=\"flag_7\"] {\n  /*france*/\n  background-position: -96px -120px;\n}\n\n/* .flag[country='flag_208'] {\n  background-position: -120px -120px;\n} */\n\n/* .flag[country='flag_45'] {\n  background-position: -144px -120px;\n} */\n\n.flag[country=\"flag_270\"] {\n  /*Georgia*/\n  background-position: -168px -120px;\n}\n\n.flag[country=\"flag_30\"] {\n  /*germany*/\n  background-position: -192px -120px;\n}\n\n.flag[country=\"flag_542\"] {\n  /*ghana*/\n  background-position: -216px -120px;\n}\n\n/* .flag[country='flag_44'] {\n  background-position: -240px -120px;\n} */\n\n/* .flag[country='flag_2'] {\n  background-position: -264px -120px;\n} */\n\n.flag[country=\"flag_542\"] {\n  /*greece*/\n  background-position: -288px -120px;\n}\n\n/* .flag[country='flag_210'] {\n  background-position: -312px -120px;\n} */\n\n/* .flag[country='flag_41'] {\n  background-position: -336px -120px;\n} */\n\n/* .flag[country='flag_46'] {\n  background-position: -360px -120px;\n} */\n\n/* .flag[country='flag_51'] {\n  background-position: 0 -144px;\n} */\n\n.flag[country=\"flag_365\"] {\n  /*guatemala*/\n  background-position: -24px -144px;\n}\n\n.flag[country=\"flag_guernsey\"] {\n  background-position: -48px -144px;\n}\n\n/* .flag[country='flag_237'] {\n  background-position: -72px -144px;\n} */\n\n/* .flag[country='flag_211'] {\n  background-position: -96px -144px;\n} */\n\n/* .flag[country='flag_52'] {\n  background-position: -120px -144px;\n} */\n\n/* .flag[country='flag_56'] {\n  background-position: -144px -144px;\n} */\n\n.flag[country=\"flag_437\"] {\n  /*honduras*/\n  background-position: -168px -144px;\n}\n\n/* .flag[country='flag_53'] {\n  background-position: -192px -144px;\n} */\n\n.flag[country=\"flag_11\"] {\n  /*hungary*/\n  background-position: -216px -144px;\n}\n\n.flag[country=\"flag_10\"] {\n  /*iceland*/\n  background-position: -240px -144px;\n}\n\n.flag[country=\"flag_497\"] {\n  /*india*/\n  background-position: -264px -144px;\n}\n\n/* .flag[country='flag_58'] {\n  background-position: -288px -144px;\n} */\n\n.flag[country=\"flag_301\"] {\n  /*iran*/\n  background-position: -336px -144px;\n}\n\n/* .flag[country='flag_214'] {\n  background-position: -360px -144px;\n} */\n\n.flag[country=\"flag_51\"] {\n  /*Ireland*/\n  background-position: 0 -168px;\n}\n\n.flag[country=\"flag_islamic-conference\"] {\n  background-position: -24px -168px;\n}\n\n.flag[country=\"flag_isle-of-man\"] {\n  background-position: -48px -168px;\n}\n\n.flag[country=\"flag_66\"] {\n  /*israel*/\n  background-position: -72px -168px;\n}\n\n.flag[country=\"flag_31\"] {\n  /*italy*/\n  background-position: -96px -168px;\n}\n\n/* .flag[country='flag_63'] {\n  background-position: -120px -168px;\n} */\n\n.flag[country=\"flag_jersey\"] {\n  background-position: -144px -168px;\n}\n\n.flag[country=\"flag_329\"] {\n  /*jordan*/\n  background-position: -168px -168px;\n}\n\n.flag[country=\"flag_278\"] {\n  /*kazakhstan*/\n  background-position: -192px -168px;\n}\n\n.flag[country=\"flag_805\"] {\n  /*kenya*/\n  background-position: -216px -168px;\n}\n\n/* .flag[country='flag_151'] {\n  background-position: -240px -168px;\n} */\n\n/* .flag[country='flag_154'] {\n  background-position: -264px -168px;\n} */\n\n.flag[country=\"flag_291\"] {\n  background-position: -288px -168px;\n}\n\n/* .flag[country='flag_253'] {\n  background-position: -312px -168px;\n} */\n\n/* .flag[country='flag_155'] {\n  background-position: -336px -168px;\n} */\n\n/* .flag[country='flag_150'] {\n  background-position: -360px -168px;\n} */\n\n/* .flag[country='flag_157'] {\n  background-position: 0 -192px;\n} */\n\n.flag[country=\"flag_163\"] {\n  /*latvia*/\n  background-position: -24px -192px;\n}\n\n/* .flag[country='flag_158'] {\n  background-position: -48px -192px;\n} */\n\n/* .flag[country='flag_127'] {\n  background-position: -72px -192px;\n} */\n\n/* .flag[country='flag_liberia'] {\n  background-position: -96px -192px;\n} */\n\n/* .flag[country='flag_130'] {\n  background-position: -120px -192px;\n} */\n\n/* .flag[country='flag_67'] {\n  background-position: -144px -192px;\n} */\n\n.flag[country=\"flag_160\"] {\n  /*lithuania*/\n  background-position: -168px -192px;\n}\n\n.flag[country=\"flag_197\"] {\n  /*luxembourg*/\n  background-position: -192px -192px;\n}\n\n/* .flag[country='flag_109'] {\n  background-position: -216px -192px;\n} */\n\n/* .flag[country='flag_234'] {\n  background-position: -240px -192px;\n} */\n\n/* .flag[country='flag_133'] {\n  background-position: -264px -192px;\n} */\n\n/* .flag[country='flag_115'] {\n  background-position: -288px -192px;\n} */\n\n.flag[country=\"flag_85\"] {\n  /*malaysia*/\n  background-position: -312px -192px;\n}\n\n/* .flag[country='flag_114'] {\n  background-position: -336px -192px;\n} */\n\n/* .flag[country='flag_106'] {\n  background-position: -360px -192px;\n} */\n\n.flag[country=\"flag_134\"] {\n  /*malta*/\n  background-position: 0 -216px;\n}\n\n/* .flag[country='flag_105'] {\n  background-position: -24px -216px;\n} */\n\n/* .flag[country='flag_110'] {\n  \n  background-position: -48px -216px;\n} */\n\n/* .flag[country='flag_111'] {\n  background-position: -72px -216px;\n} */\n\n/* .flag[country='flag_113'] {\n  \n  background-position: -96px -216px;\n} */\n\n.flag[country=\"flag_12\"] {\n  /*mexico*/\n  background-position: -120px -216px;\n}\n\n/* .flag[country='flag_40'] {\n  background-position: -144px -216px;\n} */\n\n.flag[country=\"flag_279\"] {\n  /*moldova*/\n  background-position: -168px -216px;\n}\n\n/* .flag[country='flag_132'] {\n  background-position: -192px -216px;\n} */\n\n/* .flag[country='flag_108'] {\n  background-position: -216px -216px;\n} */\n\n.flag[country=\"flag_386\"] {\n  /*montenegro*/\n  background-position: -240px -216px;\n}\n\n/* .flag[country='flag_112'] {\n  background-position: -264px -216px;\n} */\n\n.flag[country=\"flag_303\"] {\n  /*morocco*/\n  background-position: -288px -216px;\n}\n\n/* .flag[country='flag_117'] {\n  background-position: -312px -216px;\n} */\n\n.flag[country=\"flag_107\"] {\n  background-position: -96px -168px;\n}\n\n.flag[country=\"flag_nato\"] {\n  background-position: -360px -216px;\n}\n\n/* .flag[country='flag_118'] {\n  background-position: 0 -240px;\n} */\n\n/* .flag[country='flag_35'] {\n  background-position: -24px -240px;\n} */\n\n/* .flag[country='flag_124'] {\n  background-position: -48px -240px;\n} */\n\n/* .flag[country='flag_167'] {\n  background-position: -72px -240px;\n} */\n\n.flag[country=\"flag_holland\"],\n.flag[country=\"flag_35\"] {\n  /*netherlands*/\n  background-position: -96px -240px;\n}\n\n/* .flag[country='flag_33'] {\n  background-position: -120px -240px;\n} */\n\n/* .flag[country='flag_126'] {\n  background-position: -144px -240px;\n} */\n\n.flag[country=\"flag_389\"] {\n  /*nicaragua*/\n  background-position: -168px -240px;\n}\n\n/* .flag[country='flag_532'] {\n  background-position: -192px -240px;\n} */\n\n.flag[country=\"flag_532\"] {\n  /*nigeria*/\n  background-position: -216px -240px;\n}\n\n/* .flag[country='flag_66'] {\n  background-position: -240px -240px;\n} */\n\n.flag[country=\"flag_northamerica\"] {\n  background-position: -264px -240px;\n}\n\n.flag[country=\"flag_northern-cyprus\"] {\n  background-position: -288px -240px;\n}\n\n/* .flag[country='flag_241'] {\n  background-position: -312px -240px;\n} */\n\n.flag[country=\"flag_5\"] {\n  /*norway*/\n  background-position: -336px -240px;\n}\n\n.flag[country=\"flag_opec\"] {\n  background-position: -360px -240px;\n}\n\n.flag[country=\"flag_olimpic-movement\"] {\n  background-position: 0 -264px;\n}\n\n.flag[country=\"flag_olympicgames\"] {\n  background-position: -24px -264px;\n}\n\n.flag[country=\"flag_77\"] {\n  /*oman*/\n  background-position: -48px -264px;\n}\n\n/* .flag[country='flag_21'] {\n  background-position: -72px -264px;\n} */\n\n/* .flag[country='flag_77'] {\n  background-position: -96px -264px;\n} */\n\n/* .flag[country='flag_246'] {\n  \n  background-position: -120px -264px;\n} */\n\n.flag[country=\"flag_526\"] {\n  /*panama*/\n  background-position: -144px -264px;\n}\n\n/* .flag[country='flag_20'] {\n  background-position: -168px -264px;\n} */\n\n.flag[country=\"flag_280\"] {\n  /*paraguay*/\n  background-position: -192px -264px;\n}\n\n.flag[country=\"flag_20\"] {\n  /*peru*/\n  background-position: -216px -264px;\n}\n\n/* .flag[country='flag_222'] {\n  background-position: -240px -264px;\n} */\n\n.flag[country=\"flag_47\"] {\n  /*poland*/\n  background-position: -264px -264px;\n}\n\n.flag[country=\"flag_44\"] {\n  /*Portugal*/\n  background-position: -288px -264px;\n}\n\n/* .flag[country='flag_25'] {\n  background-position: -312px -264px;\n} */\n\n/* .flag[country='flag_223'] {\n  background-position: -336px -264px;\n} */\n\n.flag[country=\"flag_red-cross\"] {\n  background-position: -360px -264px;\n}\n\n.flag[country=\"flag_republicofireland\"] {\n  background-position: 0 -288px;\n}\n\n/* .flag[country='flag_256'] {\n  background-position: -24px -288px;\n} */\n\n.flag[country=\"flag_77\"] {\n  /*romania*/\n  background-position: -48px -288px;\n}\n\n.flag[country=\"flag_21\"] {\n  /*russia*/\n  background-position: -72px -288px;\n}\n\n/* .flag[country='flag_26'] {\n  background-position: -96px -288px;\n} */\n\n/* .flag[country='flag_159'] {\n  background-position: -120px -288px;\n} */\n\n/* .flag[country='flag_224'] {\n  background-position: -144px -288px;\n} */\n\n/* .flag[country='flag_88'] {\n  background-position: -168px -288px;\n} */\n\n/* .flag[country='flag_91'] {\n  background-position: -192px -288px;\n} */\n\n/* .flag[country='flag_80'] {\n  background-position: -216px -288px;\n} */\n\n.flag[country=\"flag_22\"] {\n  /*scotland*/\n  background-position: -240px -288px;\n}\n\n.flag[country=\"flag_886\"] {\n  /*senegal*/\n  background-position: -264px -288px;\n}\n\n.flag[country=\"flag_152\"] {\n  /*serbia*/\n  background-position: -288px -288px;\n}\n\n.flag[country=\"flag_seyshelles\"] {\n  background-position: -312px -288px;\n}\n\n/* .flag[country='flag_87'] {\n  background-position: -336px -288px;\n} */\n\n.flag[country=\"flag_45\"] {\n  /*singapore*/\n  background-position: -360px -288px;\n}\n\n.flag[country=\"flag_23\"] {\n  /*slovakia*/\n  background-position: 0 -312px;\n}\n\n.flag[country=\"flag_24\"] {\n  /*slovenia*/\n  background-position: -24px -312px;\n}\n\n/* .flag[country='flag_81'] {\n  background-position: -48px -312px;\n} */\n\n/* .flag[country='flag_89'] {\n  background-position: -72px -312px;\n} */\n\n.flag[country=\"flag_somaliland\"] {\n  background-position: -96px -312px;\n}\n\n/* .flag[country='flag_14'] {\n  background-position: -120px -312px;\n} */\n\n.flag[country=\"flag_southkorea-copy\"] {\n  background-position: -144px -312px;\n}\n\n.flag[country=\"flag_southkorea\"] {\n  background-position: -168px -312px;\n}\n\n.flag[country=\"flag_32\"] {\n  /*spain*/\n  background-position: -192px -312px;\n}\n\n/* .flag[country='flag_160'] {\n  background-position: -216px -312px;\n} */\n\n/* .flag[country='flag_153'] {\n  background-position: -240px -312px;\n} */\n\n/* .flag[country='flag_7'] {\n  background-position: -264px -312px;\n} */\n\n/* .flag[country='flag_226'] {\n  background-position: -288px -312px;\n} */\n\n/* .flag[country='flag_90'] {\n  background-position: -312px -312px;\n} */\n\n/* .flag[country='flag_94'] {\n  background-position: -336px -312px;\n} */\n\n.flag[country=\"flag_9\"] {\n  /*sweden*/\n  background-position: -360px -312px;\n}\n\n.flag[country=\"flag_25\"] {\n  /*switzerland*/\n  background-position: 0 -336px;\n}\n\n/* .flag[country='flag_93'] {\n  background-position: -24px -336px;\n} */\n\n/* .flag[country='flag_tahiti-19'] {\n  background-position: -48px -336px;\n} */\n\n/* .flag[country='flag_104'] {\n  background-position: -72px -336px;\n} */\n\n/* .flag[country='flag_98'] {\n  background-position: -96px -336px;\n} */\n\n.flag[country=\"flag_803\"] {\n  /*tanzania*/\n  background-position: -120px -336px;\n}\n\n/* .flag[country='flag_30'] {\n  background-position: -144px -336px;\n} */\n\n.flag[country=\"flag_timor-leste\"] {\n  background-position: -168px -336px;\n}\n\n.flag[country=\"flag_97\"] {\n  background-position: -73px -24px;\n  /*Austria Amateur*/\n}\n\n.flag[country=\"flag_148\"] {\n  background-position: -143px -236px;\n  /*Neazland*/\n}\n\n.flag[country=\"flag_366\"] {\n  background-position: -361px -358px;\n  /* Vietnam */\n}\n\n.flag[country=\"flag_815\"] {\n  background-position: -168px -385px;\n  /* Zimbabwe */\n}\n\n.flag[country=\"flag_490\"] {\n  background-position: -360px -143px;\n  /* iraq */\n}\n.flag[country=\"flag_502\"] {\n  background-position: -121px -169px;\n  /* jamaica */\n}\n.flag[country=\"flag_512\"] {\n  background-position: -360px -143px;\n  /* Liechtenstein */\n}\n\n.flag[country=\"flag_527\"] {\n  background-position: -265px -337px;\n  /* Trinidad and Tobago */\n}\n\n.flag[country=\"flag_99000086\"] {\n  background-position: -312px -291px;\n  /* Seychelless */\n}\n\n.flag[country=\"flag_99000059\"] {\n  background-position: -313px -265px;\n  /* Puerto Rico */\n}\n\n.flag[country=\"flag_1000157\"] {\n  background-position: -1px -26px;\n  /* Aruba */\n}\n\n.flag[country=\"flag_847\"] {\n  background-position: -241px -266px;\n  /* phillipeans */\n}\n\n.flag[country=\"flag_951\"] {\n  background-position: -241px -266px;\n  /* Rwanda */\n}\n\n.flag[country=\"flag_1031\"] {\n  background-position: -119px -95px;\n  /* Dominican Republic */\n}\n\n.flag[country=\"flag_1000150\"] {\n  background-position: -119px -95px;\n  /* Gambia */\n}\n.flag[country=\"flag_99000102\"] {\n  background-position: -73px -95px;\n  /* Djibouti  */\n}\n\n.flag[country=\"flag_773\"] {\n  background-position: -192px -217px;\n  /* mocao */\n}\n\n.flag[country=\"flag_792\"] {\n  background-position: -192px -217px;\n  /* Barbados */\n}\n\n.flag[country=\"flag_829\"] {\n  background-position: -289px -193px;\n  /* Malawi */\n}\n.flag[country=\"flag_600\"] {\n  background-position: -335px -193px;\n  /* Maldives  */\n}\n\n.flag[country=\"flag_1360\"] {\n  background-position: -95px -47px;\n  /* Brunei Darussalam    */\n}\n\n.flag[country=\"flag_1000275\"] {\n  background-position: -24px -24px;\n  /* North & Central America    */\n}\n\n.flag[country=\"flag_99000068\"] {\n  background-position: -239px -384px;\n  /* Internazional Women   */\n}\n\n.flag[country=\"flag_181\"] {\n  background-position: 0px 0px;\n  /* Hopman Cup  */\n}\n\n.flag[country=\"flag_74\"] {\n  background-position: -173px -405px;\n  /* Federation Cup  */\n}\n\n.flag[country=\"flag_1000262\"] {\n  background-position: -359px -72px;\n  /* Cuba  */\n}\n.flag[country=\"flag_99000106\"] {\n  background-position: -240px -24px;\n\n  /* Belgium Amateur  */\n}\n\n.flag[country=\"flag_1000369\"] {\n  background-position: -95px -193px;\n  /* Liberia  */\n}\n\n.flag[country=\"flag_99000008\"] {\n  background-position: -239px -193px;\n  /* North Macedonia  */\n}\n.flag[country=\"flag_1000306\"] {\n  background-position: -313px -218px;\n  /* Muritania  */\n}\n\n.flag[country=\"flag_806\"] {\n  background-position: -72px -218px;\n  /* Mozambique  */\n}\n\n.flag[country=\"flag_1000207\"] {\n  background-position: -264px -168px;\n  /* South Korea  */\n}\n.flag[country=\"flag_99000128\"] {\n  background-position: -240px -311px;\n  /* Saint Kitts & Nevis  */\n}\n\n.flag[country=\"flag_1000174\"] {\n  background-position: -72px -72px;\n  /* Taiwan  */\n}\n\n.flag[country=\"flag_1000202\"] {\n  background-position: -312px -72px;\n  /* Republic of Ireland  */\n}\n.flag[country=\"flag_944\"] {\n  background-position: -288px -0px;\n  /* Antigua and Barbuda  */\n}\n\n.flag[country=\"flag_905\"] {\n  background-position: -47px -242px;\n  /* Nepal  */\n}\n\n.flag[country=\"flag_99000018\"] {\n  background-position: -0px -242px;\n  /* Namibia  */\n}\n\n.flag[country=\"flag_790\"] {\n  background-position: -265px -291px;\n  /* Myanmar */\n}\n\n.flag[country=\"flag_804\"] {\n  background-position: -46px -49px;\n  /* botsawana */\n}\n\n.flag[country=\"flag_158\"] {\n  background-position: -22px -49px;\n  /* Bosnia & Herzegovina */\n}\n\n.flag[country=\"flag_1000346\"] {\n  background-position: -144px -49px;\n  /* Burkina Faso */\n}\n\n.flag[country=\"flag_1000249\"] {\n  background-position: -24px -73px;\n  /* Mali */\n}\n\n.flag[country=\"flag_380\"] {\n  background-position: -24px -337px;\n  /* syrian arab */\n}\n\n.flag[country=\"flag_390\"] {\n  background-position: -313px -69px;\n  /* ivory coast */\n}\n\n/* .flag[country='flag_227'] {\n  background-position: -216px -336px;\n} */\n\n/* .flag[country='flag_228'] {\n  background-position: -240px -336px;\n} */\n\n.flag[country=\"flag_trinidadandtobago\"] {\n  background-position: -264px -336px;\n}\n\n.flag[country=\"flag_378\"] {\n  /*tunisia*/\n  background-position: -288px -336px;\n}\n\n.flag[country=\"flag_46\"] {\n  /*turkey*/\n  background-position: -312px -336px;\n}\n\n/* .flag[country='flag_100'] {\n  background-position: -336px -336px;\n} */\n\n/* .flag[country='flag_29'] {\n  background-position: -360px -336px;\n} */\n\n/* .flag[country='flag_31'] {\n  background-position: 0 -360px;\n} */\n\n/* .flag[country='flag_163'] {\n  background-position: -24px -360px;\n} */\n\n.flag[country=\"flag_1\"] {\n  background-position: -48px -360px;\n}\n\n.flag[country=\"flag_26\"] {\n  /*usa*/\n  background-position: -72px -360px;\n}\n\n.flag[country=\"flag_86\"] {\n  /*ukraine*/\n  background-position: -120px -360px;\n}\n\n.flag[country=\"flag_united-nations\"] {\n  background-position: -144px -360px;\n}\n\n.flag[country=\"flag_unitedarabemirates\"] {\n  background-position: -168px -360px;\n}\n\n.flag[country=\"flag_unitedkingdom\"] {\n  background-position: -192px -360px;\n}\n\n.flag[country=\"flag_57\"] {\n  /*uruguay*/\n  background-position: -216px -360px;\n}\n\n/* .flag[country='flag_5'] {\n  background-position: -240px -360px;\n} */\n\n.flag[country=\"flag_vtb\"] {\n  background-position: -264px -360px;\n}\n\n/* .flag[country='flag_10'] {\n  background-position: -288px -360px;\n} */\n\n.flag[country=\"flag_vatican-city\"] {\n  background-position: -312px -360px;\n}\n\n.flag[country=\"flag_281\"] {\n  /*venezuela*/\n  background-position: -336px -360px;\n}\n\n/* .flag[country='flag_9'] {\n  background-position: -360px -360px;\n} */\n\n/* .flag[country='flag_8'] {\n  background-position: 0 -384px;\n} */\n\n/* .flag[country='flag_235'] {\n  background-position: -24px -384px;\n} */\n\n.flag[country=\"flag_131\"] {\n  /*wales*/\n  background-position: -48px -384px;\n}\n\n/* .flag[country='flag_140'] {\n  background-position: -72px -384px;\n} */\n\n/* .flag[country='flag_232'] {\n  background-position: -120px -384px;\n} */\n\n/* .flag[country='flag_233'] {\n  background-position: -144px -384px;\n} */\n\n/* .flag[country='flag_16'] {\n  background-position: -168px -384px;\n} */\n\n.flag[country=\"flag_52\"] {\n  /*japan*/\n  background-position: -192px -384px;\n}\n\n.flag[country=\"flag_rolandgarros\"] {\n  background-position: -216px -384px;\n}\n\n.flag[country=\"flag_undefined\"] {\n  background-position: -240px -384px;\n}\n\n.flag[country=\"flag_wimbledon\"] {\n  background-position: -264px -384px;\n}\n\n.flag[country=\"flag_bundesliga\"] {\n  background-position: -197px -406px;\n}\n\n.flag[country=\"flag_102\"] {\n  background-position: 0px -94px;\n}\n\n.flag[country=\"flag_252\"] {\n  background-position: -192px -360px;\n}\n\n.flag[country=\"flag_122\"] {\n  background-position: -191px -122px;\n}\n\n.flag[country=\"flag_67\"] {\n  background-position: -287px -122px;\n}\n\n.flag[country=\"flag_565\"] {\n  background-position: -310px -171px;\n}\n\n.flag[country=\"flag_130\"] {\n  background-position: -312px -237px;\n}\n\n.flag[country=\"flag_2123\"] {\n  background-position: 0px -122px;\n}\n\n.flag[country=\"flag_103\"] {\n  background-position: -95px -383px;\n}\n\n.flag[country=\"flag_828\"] {\n  background-position: -71px -73px;\n}\n\n.flag[country=\"flag_549\"] {\n  background-position: -216px -358px;\n}\n\n.flag[country=\"flag_2157\"] {\n  background-position: 0px -122px;\n}\n\n.flag[country=\"flag_3\"] {\n  background-position: 0px 0px;\n}\n\n.flag[country=\"flag_785\"] {\n  background-position: -48px -406px;\n}\n\n.flag[country=\"flag_6\"] {\n  background-position: 0px -406px;\n}\n\n.flag[country=\"flag_871\"] {\n  background-position: 0px -406px;\n}\n\n.flag[country=\"flag_27\"] {\n  background-position: -95px -383px;\n}\n\n.flag[country=\"flag_136\"] {\n  background-position: -95px -383px;\n}\n\n.flag[country=\"flag_15\"] {\n  background-position: -144px 0px;\n}\n\n.flag[country=\"flag_213\"] {\n  background-position: -48px -406px;\n}\n\n.flag[country=\"flag_297\"] {\n  background-position: -96px -21px;\n}\n\n.flag[country=\"flag_289\"] {\n  background-position: -287px -69px;\n}\n\n.flag[country=\"flag_95\"] {\n  background-position: -48px -96px;\n}\n\n.flag[country=\"flag_201\"] {\n  background-position: -23px -122px;\n}\n\n.flag[country=\"flag_159\"] {\n  background-position: -240px -190px;\n}\n\n.flag[country=\"flag_299\"] {\n  background-position: -167px -361px;\n}\n\n.flag[country=\"flag_2158\"] {\n  background-position: 0px -122px;\n}\n\n.flag[country=\"flag_72\"] {\n  background-position: -337px -385px;\n}\n\n.flag[country=\"flag_79\"] {\n  background-position: -336px -384px;\n}\n\n.flag[country=\"flag_262\"] {\n  background-position: -71px -290px;\n}\n\n.flag[country=\"flag_157\"] {\n  background-position: -71px -290px;\n}\n\n.flag[country=\"flag_1525\"] {\n  background-position: -216px -122px;\n}\n\n.flag[country=\"flag_447\"] {\n  background-position: -263px -170px;\n}\n\n.flag[country=\"flag_laliga\"] {\n  background-position: -222px -406px;\n  transform: scale(1);\n}\n\n.flag[country=\"super-lig\"] {\n  background-position: -244px -406px;\n  transform: scale(1);\n}\n\n.flag[country=\"premier-lig\"] {\n  background-position: -265px -408px;\n  transform: scale(1);\n}\n\n.flag[country=\"serie\"] {\n  background-position: -288px -408px;\n  transform: scale(1);\n}\n\n.flag[country=\"nba\"] {\n  background-position: -308px -408px;\n  transform: scale(1);\n}\n\n.flag[country=\"ufc\"] {\n  background-position: -332px -408px;\n  transform: scale(1);\n}\n\n.flag[country=\"flag_351\"] {\n  background-position: -143px -22px;\n}\n\n.flag[country=\"flag_367\"] {\n  background-position: -168px -239px;\n}\n\n.flag[country=\"flag_755\"] {\n  background-position: -71px -262px;\n}\n\n.flag[country=\"flag_56\"] {\n  background-position: -95px -383px;\n}\n\n.flag[country=\"flag_37\"] {\n  /*usa*/\n  background-position: -72px -360px;\n}\n\n.flag[country=\"flag_39\"] {\n  /*sweden*/\n  background-position: -360px -312px;\n}\n\n.flag[country=\"flag_101\"] {\n  /*russia*/\n  background-position: -72px -288px;\n}\n\n.flag[country=\"flag_42\"] {\n  background-position: -240px -266px;\n}\n\n.flag[country=\"flag_368\"] {\n  background-position: -287px -145px;\n}\n\n.flag[country=\"flag_34\"] {\n  /*australia*/\n  background-position: -48px -24px;\n}\n\n.flag[country=\"flag_64\"] {\n  /*denmark*/\n  background-position: -48px -96px;\n}\n\n.flag[country=\"flag_392\"] {\n  /*international*/\n  background-position: -239px -384px;\n}\n\n.flag[country=\"flag_284\"] {\n  /*poland*/\n  background-position: -264px -264px;\n}\n\n.flag[country=\"flag_41\"] {\n  /*germany*/\n  background-position: -192px -120px;\n}\n\n.flag[country=\"flag_275\"] {\n  /*belarus*/\n  background-position: -216px -24px;\n}\n\n.flag[country=\"flag_40\"] {\n  /*finland*/\n  background-position: -72px -120px;\n}\n\n.flag[country=\"flag_54\"] {\n  /*switzerland*/\n  background-position: 0 -336px;\n}\n\n.flag[country=\"flag_539\"] {\n  /*Philippines*/\n  background-position: -240px -267px;\n}\n\n.flag[country=\"flag_155\"] {\n  /*sweden*/\n  background-position: -360px -312px;\n}\n\n.flag[country=\"flag_421\"] {\n  /*spain*/\n  background-position: -192px -312px;\n}\n\n.flag[country=\"flag_485\"] {\n  /*thailand*/\n  background-position: -288px -75px;\n}\n\n.flag[country=\"flag_254\"] {\n  /*turkey*/\n  background-position: -312px -336px;\n}\n\n.flag[country=\"flag_107\"] {\n  /*italy*/\n  background-position: -96px -168px;\n}\n\n.flag[country=\"flag_395\"] {\n  /*mexico*/\n  background-position: -120px -216px;\n}\n\n.flag[country=\"flag_306\"] {\n  /*latvia*/\n  background-position: -24px -192px;\n}\n\n.flag[country=\"flag_98\"] {\n  /*slovakia*/\n  background-position: 0 -312px;\n}\n\n.flag[country=\"flag_1043\"] {\n  /*bhutan*/\n  background-position: -335px -23px;\n}\n\n.flag[country=\"flag_956\"] {\n  /*burundi*/\n  background-position: -168px -46px;\n}\n\n.flag[country=\"flag_827\"] {\n  /*curacao*/\n  background-position: -23px -242px;\n}\n\n.flag[country=\"flag_352\"] {\n  /*india*/\n  background-position: -264px -144px;\n}\n\n.flag[country=\"flag_787\"] {\n  /*kyrgyzstan*/\n  background-position: -360px -165px;\n}\n\n.flag[country=\"flag_1042\"] {\n  /*mongolia*/\n  background-position: -216px -215px;\n}\n\n.flag[country=\"flag_353\"] {\n  /*Qatar*/\n  background-position: -336px -266px;\n}\n\n.flag[country=\"flag_111\"] {\n  /*germany*/\n  background-position: -192px -120px;\n}\n\n.flag[country=\"flag_109\"] {\n  /*spain*/\n  background-position: -192px -312px;\n}\n\n.flag[country=\"flag_110\"] {\n  /*france*/\n  background-position: -96px -120px;\n}\n\n.flag[country=\"flag_263\"] {\n  /*brazil*/\n  background-position: -72px -48px;\n}\n\n.flag[country=\"flag_108\"] {\n  /*greece*/\n  background-position: -288px -120px;\n}\n\n.flag[country=\"flag_784\"] {\n  /*hong kong*/\n  background-position: -192px -143px;\n}\n\n.flag[country=\"flag_844\"] {\n  /*Puerto Rica*/\n  background-position: -311px -266px;\n}\n\n.flag[country=\"flag_814\"] {\n  /*usa*/\n  background-position: -72px -360px;\n}\n\n.flag[country=\"flag_373\"] {\n  /*brazil*/\n  background-position: -72px -48px;\n}\n\n.flag[country=\"flag_123\"] {\n  /*germany*/\n  background-position: -192px -120px;\n}\n\n.flag[country=\"flag_810\"] {\n  /*kazakhstan*/\n  background-position: -192px -168px;\n}\n\n.flag[country=\"flag_38\"] {\n  /*norway*/\n  background-position: -336px -240px;\n}\n.flag[country=\"flag_115\"] {\n  /*poland*/\n  background-position: -264px -264px;\n}\n.flag[country=\"flag_331\"] {\n  /*kuwait*/\n  background-position: -336px -171px;\n}\n\n.flag[country=\"flag_428\"] {\n  /*lebanon*/\n  background-position: -47px -194px;\n}\n\n.flag[country=\"flag_387\"] {\n  /*San Marino*/\n  background-position: -168px -288px;\n}\n.flag[country=\"flag_540\"] {\n  /*Palestine*/\n  background-position: -120px -263px;\n}\n\n.flag[country=\"flag_188\"] {\n  /*israel*/\n  background-position: -72px -168px;\n}\n.flag[country=\"flag_65\"] {\n  /*austria*/\n  background-position: -72px -24px;\n}\n.flag[country=\"flag_546\"] {\n  /*iceland*/\n  background-position: -240px -144px;\n}\n\n.flag[country=\"flag_339\"] {\n  /*hong kong*/\n  background-position: -192px -143px;\n}\n\n.flag[country=\"flag_190\"] {\n  /*croatia*/\n  background-position: -336px -72px;\n}\n\n.flag[country=\"flag_1017\"],\n.flag[country=\"flag_154\"] {\n  /*czech republic*/\n  background-position: -23px -97px;\n}\n.flag[country=\"flag_168\"] {\n  /*lithuania*/\n  background-position: -168px -192px;\n}\n\n.flag[country=\"flag_76\"] {\n  /*davis cup*/\n  background-position: -123px -407px;\n}\n.flag[country=\"flag_285\"] {\n  /*hungary*/\n  background-position: -216px -144px;\n}\n.flag[country=\"flag_242\"] {\n  /*france*/\n  background-position: -96px -120px;\n}\n\n.flag[country=\"flag_244\"] {\n  /*denmark*/\n  background-position: -48px -96px;\n}\n\n.flag[country=\"flag_112\"] {\n  /*turkey*/\n  background-position: -312px -336px;\n}\n.flag[country=\"flag_106\"] {\n  /*norway*/\n  background-position: -336px -240px;\n}\n.flag[country=\"flag_328\"] {\n  /*netherlands*/\n  background-position: -96px -240px;\n}\n.flag[country=\"flag_189\"] {\n  /*belgium*/\n  background-position: -240px -24px;\n}\n\n.flag[country=\"flag_114\"] {\n  /*sweden*/\n  background-position: -360px -312px;\n}\n\n.flag[country=\"flag_267\"] {\n  /*ukraine*/\n  background-position: -120px -360px;\n}\n.flag[country=\"flag_948\"] {\n  /*tunisia*/\n  background-position: -288px -336px;\n}\n.flag[country=\"flag_176\"] {\n  /*canada*/\n  background-position: -312px -48px;\n}\n\n.flag[country=\"flag_135\"] {\n  /*finland*/\n  background-position: -72px -120px;\n}\n\n.flag[country=\"flag_287\"] {\n  /*Portugal*/\n  background-position: -288px -264px;\n}\n\n.flag[country=\"flag_149\"] {\n  /*finland*/\n  background-position: -72px -120px;\n}\n\n.flag[country=\"flag_548\"] {\n  /*china*/\n  background-position: -96px -72px;\n}\n\n.flag[country=\"flag_176\"] {\n  /*canada*/\n  background-position: -312px -48px;\n}\n\n.flag[country=\"flag_126\"] {\n  /*italy*/\n  background-position: -96px -168px;\n}\n.flag[country=\"flag_135\"] {\n  /*finland*/\n  background-position: -72px -120px;\n}\n\n.flag[country=\"flag_177\"] {\n  /*sweden*/\n  background-position: -360px -312px;\n}\n.flag[country=\"flag_179\"] {\n  /*greece*/\n  background-position: -288px -120px;\n}\n\n.flag[country=\"flag_256\"] {\n  /*belgium*/\n  background-position: -240px -24px;\n}\n\n.flag[country=\"flag_313\"] {\n  /*poland*/\n  background-position: -264px -264px;\n}\n.flag[country=\"flag_398\"] {\n  /*romania*/\n  background-position: -48px -288px;\n}\n.flag[country=\"flag_457\"] {\n  /*slovakia*/\n  background-position: 0 -312px;\n}\n.flag[country=\"flag_415\"] {\n  /*oman*/\n  background-position: -48px -264px;\n}\n.flag[country=\"flag_180\"] {\n  /*france*/\n  background-position: -96px -120px;\n}\n\n.flag[country=\"flag_312\"] {\n  /*switzerland*/\n  background-position: 0 -336px;\n}\n\n.flag[country=\"flag_812\"] {\n  /*zambia*/\n  background-position: -144px -386px;\n}\n\n.flag[country=\"flag_824\"] {\n  /*uganda*/\n  background-position: -95px -362px;\n}\n\n.flag[country=\"flag_938\"] {\n  /*gibraltar*/\n  background-position: -239px -118px;\n}\n.flag[country=\"flag_372\"] {\n  /*bulgaria*/\n  background-position: -120px -48px;\n}\n\n.flag[country=\"flag_307\"] {\n  /*england*/\n  background-position: -216px -96px;\n}\n\n.flag[country=\"flag_195\"] {\n  /*turkey*/\n  background-position: -312px -336px;\n}\n.flag[country=\"flag_129\"] {\n  /*spain*/\n  background-position: -192px -312px;\n}\n.flag[country=\"flag_146\"] {\n  /*netherlands*/\n  background-position: -96px -240px;\n}\n.flag[country=\"flag_265\"] {\n  /*Portugal*/\n  background-position: -288px -264px;\n}\n.flag[country=\"flag_128\"] {\n  /*austria*/\n  background-position: -72px -24px;\n}\n.flag[country=\"flag_138\"] {\n  /*switzerland*/\n  background-position: 0 -336px;\n}\n\n.flag[country=\"flag_171\"] {\n  /*norway*/\n  background-position: -336px -240px;\n}\n.flag[country=\"flag_196\"] {\n  /*czech republic*/\n  background-position: -23px -97px;\n}\n.flag[country=\"flag_199\"] {\n  /*denmark*/\n  background-position: -48px -96px;\n}\n\n.flag[country=\"flag_283\"] {\n  /*croatia*/\n  background-position: -336px -72px;\n}\n.flag[country=\"flag_608\"] {\n  /*aruba*/\n  background-position: 0px -23px;\n}\n\n.flag[country=\"flag_257\"] {\n  /*albania*/\n  background-position: -95px 0px;\n}\n\n.flag[country=\"flag_914\"] {\n  /*ethiopia*/\n  background-position: -312px -98px;\n}\n\n.flag[country=\"flag_117\"] {\n  /*england*/\n  background-position: -216px -96px;\n}\n.flag[country=\"flag_483\"] {\n  /*japan*/\n  background-position: -192px -384px;\n}\n\n.flag[country=\"flag_1451\"] {\n  /*kosovo*/\n  background-position: -313px -167px;\n}\n\n.flag[country=\"flag_376\"] {\n  /*andorra*/\n  background-position: -192px 0px;\n}\n.flag[country=\"flag_258\"] {\n  /*latvia*/\n  background-position: -24px -192px;\n}\n.flag[country=\"flag_324\"] {\n  /*romania*/\n  background-position: -48px -288px;\n}\n.flag[country=\"flag_288\"] {\n  /*serbia*/\n  background-position: -288px -288px;\n}\n\n.flag[country=\"flag_771\"] {\n  /*china*/\n  background-position: -96px -72px;\n}\n\n.flag[country=\"flag_561\"] {\n  /*japan*/\n  background-position: -192px -384px;\n}\n\n.flag[country=\"flag_340\"] {\n  /*serbia*/\n  background-position: -288px -288px;\n}\n.flag[country=\"flag_375\"] {\n  background-position: -168px -312px;\n}\n\n.flag[country=\"flag_747\"] {\n  background-position: -240px -188px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
